import {
  ActivatedRouteSnapshot,
  CanActivate,
  Route,
  Router,
  RouterStateSnapshot,
} from '@angular/router';

import { AuthenticationService } from './authentication.service';
import { Injectable } from '@angular/core';
import { Observable } from 'rxjs/Observable';
import { UsersService } from './users.service';

@Injectable()
export class HomeGuard implements CanActivate {

  constructor(
    private authenticationService: AuthenticationService,
    private usersService: UsersService,
    private router: Router) { }

  canActivate(route: ActivatedRouteSnapshot, state: RouterStateSnapshot) {
    return this.usersService.currentUser.map(user => {
      if (!user) {
        this.router.navigate(['/login'], { queryParams: { redirectTo: state.url } });
      } else {
        if (user.roles.length > 1) {
          // More than 1 role, go to dashboard
          this.router.navigate(['/c']);
        } else if (user.isAssessor) {
          this.router.navigate(['/a']);
        } else if (user.isEditor) {
          this.router.navigate(['/q']);
        } else if (user.isManager) {
          this.router.navigate(['/p']);
        } else if (user.isAnalyst) {
          this.router.navigate(['/m']);
        } else if (user.isAdministrator) {
          this.router.navigate(['/c']);
        } else if (user.isReviewer) {
          this.router.navigate(['/a']);
        }
      }
      return false;
    });

  }

}



// WEBPACK FOOTER //
// C:/Users/Pablo/source/repos/prote/angular/src/app/core/services/home-guard.service.ts